import { render, staticRenderFns } from "./AdminDefaultHsaStoreConfiguration.vue?vue&type=template&id=56a3b8bd"
import script from "./AdminDefaultHsaStoreConfiguration.vue?vue&type=script&lang=ts"
export * from "./AdminDefaultHsaStoreConfiguration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports